import React, { useState, useEffect, useContext } from 'react'
import { apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/pathObj'
import { useForm } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import OInputField from 'components/reusable/OInputField'
import { useTranslation } from 'react-i18next'
import { preventMaxInput } from 'utils/validations'
import formValidation from '../../utils/formValidation'
import OTextArea from 'components/reusable/OTextArea'
import AuthContext from 'context/AuthContext'

const SupportAdd = ({ getSupport, handleCategory, item }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const { user } = useContext(AuthContext)
  const [companyData] = useState(user?._id)
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {}
  })

  const onSubmit = async data => {
    try {
      const payload = {
        name: data.name,
        email: data?.email,
        description: data?.description,
        companyID: companyData
      }
      const res = await apiPost(apiPath.supportAdd, payload)
      if (res?.data?.success) {
        getSupport()
        handleCategory(false)
        notification.success(res?.data?.message)
      } else {
        notification.error(res?.data?.message)
      }
    } catch (err) {
      console.log('err:', err)
    }
  }

  useEffect(() => {
    reset({
      name: user.name,
      email: user.officialEmail
    })
  }, [user])

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('NEW_QUERY')}</h3>
                <button
                  onClick={() => handleCategory(false)}
                  className='leading-none  ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl font-extralight outline-none focus:outline-none'
                  title='Close'
                >
                  <span title='Close' className=' text-[#B8BBBF]  text-4xl '>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className='grid sm:grid-cols-2'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      <OInputField
                        maxLength={100}
                        onInput={e => preventMaxInput(e, 100)}
                        register={register(
                          'name',
                          formValidation['companyName']
                        )}
                        wrapperClassName='relative z-0 w-full group'
                        name='name'
                        inputLabel={
                          <>
                            {t('COMPANY_NAME')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        errors={errors}
                        type='text'
                        autoFocus
                      />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      <OInputField
                        register={register('email', formValidation['email'])}
                        errors={errors}
                        wrapperClassName='relative z-0 w-full group'
                        id='email'
                        type='text'
                        name='email'
                        inputLabel={
                          <>
                            {t('EMAIL_ADDRESS')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        maxLength={50}
                        onInput={e => preventMaxInput(e, 50)}
                      />
                    </div>
                  </div>
                </div>
                <div className='grid'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='group relative z-0 w-full '>
                      <OTextArea
                        errors={errors}
                        wrapperClassName='relative z-0 w-full group'
                        name='description'
                        inputLabel={
                          <>
                            {t('DESCRIPTION')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='textarea'
                        register={register(
                          'description',
                          formValidation['supportDescription']
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  onClick={() => handleCategory(false)}
                  className='ease-linear text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  transition-all duration-150'
                  type='button'
                >
                  {t('O_BACK')}
                </button>
                <button
                  className='bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                  type='submit'
                  onClick={handleSubmit(onSubmit)}
                >
                  {t('O_ADD')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default SupportAdd
